import { useMutation } from "@tanstack/react-query";
import { PushNotificationControllerApi } from "../../services";
import { getConfigObject } from "../../utils/utils";

interface Props {
  xTENANTID?: string;
}

/**
 * @author [Atish Bagate]
 */
export const useReadAllNotification = () =>
  useMutation({
    mutationFn: async (props: Props) => {
      return new PushNotificationControllerApi(
        getConfigObject()
      ).maskAsReadNotification1(props?.xTENANTID);
    },
  });
